const wishlistData = JSON.parse(localStorage.getItem("wishlist")) || [];
const wishlistBlock = document.querySelector(".js-wishlistBlock");
wishlistBlock.innerHTML = "";
const wishlistHtml = wishlistData
  .map(
    (item) => `
          <div class="wishlist-product__list" id="product-${item.productVariantId}">
  <div class="c-product">
    <a href="${item.productUrl}">
      <img src="${item.productImg}" alt="${item.productTitle}">
    </a>
    <div class="wish-text">
      <h3 class="c-product__title card__heading h5">
        <a class="full-unstyled-link" href="${item.productUrl}">${item.productTitle}</a>
      </h3>
      <p class="price hidden" id="price-${item.productVariantId}">${item.productPrice}</p>
    </div>
    <div class="wish-buttons">
      <form action="/cart/add" method="post" enctype="multipart/form-data">
        <input type="hidden" name="id" value="${item.productVariantId}" />
        <input class="wish-button hidden" type="submit" value="${window.globalTranslations.add_to_cart}" id="add-to-cart-${item.productVariantId}" />
      </form>
      <button class="circleXMarkButtonContentContainer" onclick="removeFromWishlist('${item.productVariantId}')">
        <!-- SVG Icon here -->
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill-rule="evenodd" clip-rule="evenodd">
          <path d="M12 0c6.623 0 12 5.377 12 12s-5.377 12-12 12-12-5.377-12-12 5.377-12 12-12zm0 1c6.071 0 11 4.929 11 11s-4.929 11-11 11-11-4.929-11-11 4.929-11 11-11zm0 10.293l5.293-5.293.707.707-5.293 5.293 5.293 5.293-.707.707-5.293-5.293-5.293 5.293-.707-.707 5.293-5.293-5.293-5.293.707-.707 5.293 5.293z"></path>
        </svg>
      </button>
    </div>
  </div>
</div>

          `
  )
  .join("");

if (wishlistBlock) {
  wishlistBlock.innerHTML = wishlistHtml;
}

wishlistData.forEach((item) => {
  fetch(`/products/${item.productHandle}.js`)
    .then((response) => response.json())
    .then((data) => {
      const variant = data.variants.find((v) => v.id == item.productVariantId);
      if (variant) {
        const priceElement = document.getElementById(
          `price-${item.productVariantId}`
        );
        const addButton = document.getElementById(
          `add-to-cart-${item.productVariantId}`
        );
        priceElement.textContent = `€${(variant.price / 100).toFixed(2)} EUR`;
        addButton.disabled = !variant.available;
        priceElement.classList.remove("hidden");
        addButton.classList.remove("hidden");
      }
    })
    .catch((error) => console.error("Error fetching product details:", error));
});
